import { BrowserType } from './browser.types'

export const detectBrowser = (): BrowserType => {
  if (typeof navigator === 'undefined') return BrowserType.UNKNOWN

  const { userAgent } = navigator

  if (/firefox/i.test(userAgent)) return BrowserType.FIREFOX
  if (/edg/i.test(userAgent)) return BrowserType.EDGE // важно: раньше чем Chrome!
  if (/opr\//i.test(userAgent) || /opera/i.test(userAgent)) return BrowserType.OPERA
  if (/chrome|crios/i.test(userAgent)) return BrowserType.CHROME
  if (/safari/i.test(userAgent) && !/chrome|crios|android/i.test(userAgent)) return BrowserType.SAFARI

  return BrowserType.UNKNOWN
}
